import React from "react";
import FormProgress from "../UnitAdmin/FormProgress";
import VersioningFullScopeAccordion from "./VersioningFullScopeAccordion";

const VersioningFullScope = () => {
  return (
    <>
      <div className="addendum-main-container">
        <FormProgress />
        <div className="addendum-heading">Mars QMS - QMS Full Scope</div>
        <VersioningFullScopeAccordion />
      </div>
    </>
  );
};

export default VersioningFullScope;
